module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitleb"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('span', {
    staticClass: "bb"
  }, [_vm._v("Prologue")])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("T")]), _vm._v("he appointed hour had finally arrived. Colonel Hayne walked to the place of his execution, preferring to travel by foot rather than endure the degradation of riding in a cart. Even so, he bore the indignity of having his arms pinioned. The cart that followed was empty, except for the driver and one other thing: the coffin that had been thrust into his cell the night before in a wanton act of cruelty. Along the way he was accompanied by a friend who carried an umbrella to shade his hatless head from the searing August sun. A clergyman and a few of Hayne’s other friends trod behind."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/30_Notes#rfnr_1",
      "id": "fnr_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hayne regarded the familiar streets of Charleston as he purposefully strode toward his destiny. The streets were crowded with thousands of anxious spectators, yet the morning was dolefully silent aside from the rattle and tramp of Hayne’s military escort. A few bystanders quietly offered words of encouragement or a “God bless and keep you, Colonel.” Many wept."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Notes#rfnr_2",
      "id": "fnr_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The dreaded destination was just beyond the city lines at a place within a stone’s throw of where the Orphan House would later be built. Upon reaching the outskirts, the soldiers formed a hollow square around the scaffold, the British troops occupying the front and rear and the Hessians forming on the right and left. The hangman, masked and muffled to conceal his identity, patiently waited to perform his grim duty."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Notes#rfnr_3",
      "id": "fnr_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To the British, Hayne was a traitor. To Americans, he would be a martyr.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let the prisoner prepare himself.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Notes#rfnr_4",
      "id": "fnr_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b3de91a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/12_Prologue.vue
// module id = 90
// module chunks = 0